import { render, staticRenderFns } from "./NotAuthViewMSLogout.vue?vue&type=template&id=19401c72"
import script from "./NotAuthViewMSLogout.vue?vue&type=script&lang=ts"
export * from "./NotAuthViewMSLogout.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports